<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
    <div class="row" v-if="userData.permissions['view_loan_products']==1 && userData.permissions['view_loans'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="mb-2 float-end">
              <b-button v-show="userData.permissions['new_loan_products']==1" v-b-modal.new-loantype size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Loan Product</b-button>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
              <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(addedby)="data">
                {{ data.item.addedby }}
              </template>
              <template #cell(period)="data">
                {{ data.item.period }} days
              </template>
              <template #cell(rate)="data">
                {{ data.item.rate }} %
              </template>
              <template #cell(actions)="data">
                <div class="btn-group">
                <b-button v-show="userData.permissions['edit_loan_products']==1" @click="edit(data.item.id,data.item.name,data.item.period,data.item.rate,data.item.fine )" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                <b-button v-show="userData.permissions['delete_loan_products']==1" @click="remove(data.item.id,data.item.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                </div>
              </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to view Loan Products</span></center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="new-loantype" centered title="New Loan Product" title-class="font-18" hide-footer>
        <form @submit.prevent="addLoanType">
            <div class="form-group mb-2">
            <label>Name</label>
            <input v-model="name" type="text" class="form-control" />
            <label>Period</label> <small class="text-danger">days</small>
            <input v-model="period" type="number" class="form-control" />
            <label>Monthly Rate</label> <small class="text-danger">%</small>
            <input v-model="rate" type="number" class="form-control" />
            <label>Fine <small class="text-danger">per extra day</small></label>
            <input v-model="fine" type="number" class="form-control" />
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-loantype')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="edit-loantype" centered title="Edit Loan Product" title-class="font-14" hide-footer>
        <form @submit.prevent="editLoanType">
            <div class="form-group mb-2">
            <input v-model="id" type="hidden">
            <label>Name</label>
            <input v-model="name" type="text" class="form-control" />
            <label>Period</label> <small class="text-danger">days</small>
            <input v-model="period" type="number" class="form-control" />
            <label>Monthly Rate</label> <small class="text-danger">%</small>
            <input v-model="rate" type="number" class="form-control" />
            <label>Fine <small class="text-danger">per extra day</small></label>
            <input v-model="fine" type="number" class="form-control" />
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-loantype')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="delete-loantype" centered title="Delete Loan Product" title-class="font-18" hide-footer>
        <form @submit.prevent="removeLoanType">
            <input v-model="id" type="hidden">
              Are you sure you want to delete the Loan Product : <b>{{ name }}</b> ?
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-loantype')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { loantypeMethods, loantypeComputed } from "@/state/helpers";

export default {
  page: {
    title: "Loan Products",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Layout,PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Loan Products",
      items: [ {text: "Dashboard",to: "/",}, {text: "Loan Products",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'name', label: 'Name', visible: true },
          { key: 'period', label: 'Period', visible: true },
          { key: 'rate', label: 'Monthly Rate', visible: true },
          { key: 'fine', label: 'Fine/Day', visible:true},
          { key: 'addedby', label: 'Added by', visible: true },
          { key: 'actions', label: 'Actions', visible: true },
        ],
      id:'',
      name:'',
      period:'',
      rate:'',
      fine:'0',
    };
  },
  computed: {
    ...loantypeComputed,
    List() { return this.loantypes.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.loantypes.map((d) => ({...d }))},
    IsBusy() { let a=false; if (this.loantypes.length>0) { a=false;} else { a=true;} return a },
  },
  mounted() {
    this.fetchLoanTypes();
    this.TotalRows = this.loantypes.length;
    this.isBusy=false;
  },
  methods: {
    ...loantypeMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id,name,period,rate,fine){
      this.id=id;
      this.name=name;
      this.period=period;
      this.rate=rate;
      this.fine=fine;
      this.$bvModal.show('edit-loantype')
    },
    remove(id,name){
      this.id=id;
      this.name=name;
      this.$bvModal.show('delete-loantype')
    },
    async addLoanType() { 
      let formData = new FormData();
      formData.append("name", this.name);
      formData.append("period", this.period);
      formData.append("rate", this.rate);
      formData.append("fine", this.fine);
      let url = "/addloantype";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
          this.fetchLoanTypes();
          this.$bvModal.hide('new-loantype');
          this.name="";
          this.rate="";
          this.fine="";
          this.period="";
      }
      });
    },
    async editLoanType(){ 
    let formData = new FormData();
    formData.append("id", this.id);
    formData.append("name", this.name);
    formData.append("period", this.period);
    formData.append("rate", this.rate);
    formData.append("fine", this.fine);
    let url = "/updateloantype";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchLoanTypes();
        this.$bvModal.hide('edit-loantype');
        this.name="";
        this.rate="";
        this.fine="";
        this.period="";
      }
    });
    },
    async removeLoanType() { 
    let formData = new FormData();
    formData.append("id", this.id);
    let url = "/removeloantype";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchLoanTypes();
        this.$bvModal.hide('delete-loantype');
      }
    });
    },
  },
};
</script>